define('vspot-angular/services/activity-service',['jquery'], function ($) {
    'use strict';


    return ['resources.Activity', function (Activity) {

        return {
            /*
             * Get a list of all the activities.
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            query: function() {
                return Activity.query();
            },

            /*
             * get:
             *      Retrieve a single activity.
             *
             * @param {int} id  = id of the activity to retrieve
             * @param {str} key = access key to retrieve with
             * @returns Resource object
             */
            get: function (id, key) { 

                return Activity.get({
                    id:         id,
                    accesskey:  key
                });
            },
            /*
             * getSummary:
             *      Retrieve a single activity, just the summary data. Works with currently authenticated
             * user, registered or participant
             *
             * @param {int} id  = id of the activity to retrieve
             * @returns Resource object
             */
            getSummary: function (id) {

                return Activity.getSummary({
                    id:         id
                });
            },

        };
    }];
});

